import React, { memo, useMemo } from 'react';
import ListComponent from '../../List';
const List = _ref => {
  let {
    items,
    ...otherProps
  } = _ref;
  const listProps = useMemo(() => {
    const finalItems = items.filter(item => item.type === 'li').map(item => {
      var _item$props;
      return (item === null || item === void 0 || (_item$props = item.props) === null || _item$props === void 0 ? void 0 : _item$props.children) || null;
    });
    return {
      items: finalItems,
      ...otherProps
    };
  }, [items, otherProps]);
  return /*#__PURE__*/React.createElement(ListComponent, listProps);
};
export default /*#__PURE__*/memo(List);